export default __webpack_public_path__ + "images/44dce1c60bf1d27fdcb85038135ba9b1-literaryarts.jpg";